module.exports = __webpack_public_path__ + "img/hate_highlight.06951f7.png";